<template>
  <div>
    <b-form-group
      id="input-type-group"
      label="Type:"
      label-for="input-type"
    >
      <b-form-input
        id="input-type"
        v-model="model.type"
        placeholder="Type"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      id="input-comment-group"
      label="Comment:"
      label-for="input-comment"
    >
      <b-form-textarea
        id="input-comment"
        placeholder="Comment"
        v-model="model.comment"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-form-group>
  </div>
</template>

<style scoped>
</style>

<script>
  import HelpStore from '@/store/helpstore.js'

  export default {
    name: 'WritingtypeNewEdit',
    props: ['writingtype'],
    data(){
      return {
        // TODO: fetch from API
        model: (this.writingtype ? this.writingtype : {
          type: null,
          comment: null
        })
      }
    },
    updated(){
      HelpStore.item = this.model
    },
  }
</script>
